import * as React from 'react';

export const LoginView: React.FC = () => {
  const handleClick = React.useCallback<(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void>(() => {
    // eslint-disable-next-line no-unused-expressions
    window._headerTrackingEvent?.('login');
    // eslint-disable-next-line no-unused-expressions
    window.waitForLoginPopup?.();
  }, []);

  return (
    <span className="c-header__cabinet-mobile-wrap">
      <a id="login-btn" onClick={handleClick} href="#" className="c-header__cabinet-mobile c-header-link">
        <span className="c-header__cabinet-mobile-text">Войти</span>
      </a>
    </span>
  );
};

LoginView.displayName = 'LoginView';
